/*
 *   File : account.js
 *   Author : https://evoqins.com
 *   Description : Account settings page 
 *   Integrations : 
 *   Version : 1.0.0
*/

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Modal } from "bootstrap";
import Cookies from "js-cookie";

// Components
import { Icon } from "../../Component/Icon";
import { ProfileCard } from "../../Component/Cards";
import { ConfirmLogoutModal } from "../../Component/Modal";
import { _scrollToTop } from "../../Helper";

// Styles
import Styles from "../../Styles/Component/account.module.scss";

// Assets
import ToggleDisabled from "../../Assets/Images/Icons/Accounts/toggle-disabled.svg";
import ToggleEnabled from "../../Assets/Images/Icons/Accounts/toggle-enabled.svg";

// Custom data
const ACC_MGT = [
    {
        id: 1,
        name: "Mapped Brokers",
        des: "Check your linked broker accounts",
        icon: "mapped-brokers",
        navigation: true,
        path: "brokers"
    },
];

const SETTINGS = [
    {
        id: 1,
        name: "Edit Profile",
        des: "Change Profile picture, phone number and email ",
        icon: "edit-profile",
        navigation: true,
        path: "edit-profile"
    },
    // {
    //     id: 2,
    //     name: "Change MPIN",
    //     des: "Update your MPIN to login securely ",
    //     icon: "change-mpin",
    //     navigation: true,
    //     path: "change-pin"
    // },
    // {
    //     id: 3,
    //     name: "Whatsapp Notifications",
    //     des: "Provide/deny permissions to be notified on WhatsApp.",
    //     icon: "notification",
    //     navigation: false
    // },
    {
        id: 4,
        name: "FAQ",
        des: "Go through Frequently Asked Questions",
        icon: "faq",
        navigation: true,
        path: "/faq",
    }
];

const MORE_SETTINGS = [
    {
        id: 1,
        name: "Terms & Conditions",
        des: "Review the rules and guidelines for using our app",
        icon: "terms-conditions",
        navigation: true,
        public: true,
        path: "/terms-conditions",
    },
    {
        id: 2,
        name: "Privacy Policy",
        des: "This policy explains our data practices in detail",
        icon: "privacy-policy",
        public: true,
        navigation: true,
        path: "/privacy-policy",
    },
    {
        id: 4,
        name: "Log out",
        des: "",
        icon: "logout",
        navigation: true,
        type: 2
    }
];

function Account(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [enableNotification, setEnableNotification] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    useEffect(() => {
        // Scroll the page to top
        _scrollToTop();
    }, []);

    useEffect(() => {
        if (showLogoutModal === true) {
            const logout_modal = new Modal(document.getElementById('confirm-logout-modal'));
            logout_modal.show();
        }
    }, [showLogoutModal]);

    // handle navigate
    const _handleNavigate = (data) => {

        if (data.type === 2) {
            setShowLogoutModal(true);
            return;
        };

        if (data.navigation) {
            navigate(data.path);
            if (data.public) {
                props.handlePublicRouter();
            }
        }
    };

    // handle toggle notification
    const _handleEnableNotification = () => {
        setEnableNotification(prev => !prev);
    };

    // handle Logout
    const _handleLogout = () => {
        let options = { domain: process.env.REACT_APP_DOMAIN, path: '/' };
        dispatch({ type: "CLEAR_STORE" });
        Cookies.remove("indvestment_access_token", options);
        Cookies.remove("indvestment_user_id", options);
        Cookies.remove("indvestment_token_expiry_time", options);
        localStorage.removeItem("indvestment_refresh_token");
        localStorage.removeItem("indvestment_connected_broker");
        localStorage.removeItem("indvestment_is_lumpsum_broker");
        navigate("/login");
    };

    // Inline components //
    const SectionTitle = ({ title }) => {
        return (
            <h2 className="mb-sm-1 e-text-philippine-gray e-alt-font-lato e-font-weight-500 e-font-16 line-height-24px">
                {title}
            </h2>
        )
    };

    const SettingsItems = (props) => {
        return (
            <div className="d-flex flex-column">
                {
                    props.data.map((item, key) => (
                        <div key={key}
                            className={`
                            d-flex align-items-center py-3 gap-sm-5
                            ${props.data.length !== key + 1 ? "e-border-bottom-1px-anti-flash-white" : ""}
                            ${item.navigation ? "cursor-pointer" : ""}`}
                            onClick={() => _handleNavigate(item)}>
                            <div className="col-auto flex-fill">
                                <div className="d-flex gap-3">
                                    <div className="col-auto">
                                        <Icon icon={item.icon}
                                            size={24} />
                                    </div>
                                    <div className={`col-auto flex-fill d-flex ${item.des ? "gap-2 flex-column" : "align-items-center"} `}>
                                        <p className="e-font-14-res mb-0 e-text-chinese-black e-alt-font-lato e-font-weight-400 e-font-16 line-height-16px">
                                            {item.name}
                                        </p>
                                        {
                                            item.des &&
                                            <p className="mb-0 e-text-philippine-gray e-alt-font-lato e-font-weight-400 e-font-14 line-height-14px">
                                                {item.des}
                                            </p>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                item.navigation && item.type !== 2 ?

                                    <div className="col-auto">
                                        <Icon icon={"arrow-right"}
                                            size={"12px"} />
                                    </div>
                                    :
                                    item.type !== 2 &&
                                    <img src={enableNotification ? ToggleEnabled : ToggleDisabled}
                                        alt="toggle icon"
                                        className="cursor-pointer"
                                        onClick={_handleEnableNotification} />
                            }
                        </div>
                    ))
                }
            </div>

        )
    };

    return (
        <>

            <div className="mb-3">
                <h2 className="mb-4 e-text-primary-color e-primary-font-clash-display e-font-weight-500 e-font-20 line-height-24px">
                    Accounts
                </h2>
                <div className="row flex-column flex-md-row gap-3 gap-md-0">
                    <div className="order-2 order-md-1 col-12 col-md-7 d-flex flex-column gap-3">
                        {/* Account Management */}
                        <div className={Styles.e_card_shadow}>
                            <SectionTitle title="Account Management" />
                            <SettingsItems data={ACC_MGT} />
                        </div>

                        { }
                        <div className={Styles.e_card_shadow}>
                            <SectionTitle title="Settings & Preferences" />
                            <SettingsItems data={SETTINGS} />
                        </div>

                        {/* More */}
                        <div className={Styles.e_card_shadow}>
                            <SectionTitle title="More" />
                            <SettingsItems data={MORE_SETTINGS} />
                        </div>
                    </div>
                    <div className="order-1 order-md-2 col-12 col-sm-8 col-md-5">
                        <ProfileCard />
                    </div>
                </div>
            </div>

            {
                showLogoutModal &&
                <ConfirmLogoutModal handleSuccess={_handleLogout}
                    handleClose={() => setShowLogoutModal(false)} />
            }
        </>
    )
}

export default Account;